import { Controller } from "@hotwired/stimulus"

// Export PNG du badge : sérialise le SVG (autoportant, logo en data-URI donc
// canvas non "tainted") vers un canvas 2x et déclenche le téléchargement.
export default class extends Controller {
  static targets = ["preview"]

  downloadPng() {
    const svg = this.previewTarget.querySelector("svg")
    if (!svg) return

    const w = svg.viewBox.baseVal.width || svg.width.baseVal.value || 560
    const h = svg.viewBox.baseVal.height || svg.height.baseVal.value || 720
    const xml = new XMLSerializer().serializeToString(svg)
    const src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(xml)))

    const img = new Image()
    img.onload = () => {
      const scale = 2
      const canvas = document.createElement("canvas")
      canvas.width = w * scale
      canvas.height = h * scale
      const ctx = canvas.getContext("2d")
      ctx.scale(scale, scale)
      ctx.drawImage(img, 0, 0)
      canvas.toBlob((blob) => {
        const a = document.createElement("a")
        a.href = URL.createObjectURL(blob)
        a.download = "badge-bilan-carbone.png"
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(a.href)
      }, "image/png")
    }
    img.src = src
  }
}
